require('./stylesheet/index.scss');

angular.module('pages.booking', [])
    .config(config);

config.$inject = ['$stateProvider'];
function config($stateProvider) {
    $stateProvider
        .state('pages.booking', {
            url: 'booking/:url',
            template: require('./templates/index.html'),
            controller: require('../payment/controllers/payment'),
            params: {
                fields: {},
				toEvent: null,//event to go to(for direct link to event) exmpl:pages.payment({url:configs.payments_config.service.metallist, toEvent:32776496})
				serviceId: null,
				autoCheck: null,
				subscribe: null,
				amount: null,
				counters: null,
				account: null,
				lastDate: null,
				destination: null,
				templateId: null,
                urlCode: null,
				editForbid: false
            },
            data: {
                restricted: false,
                iframe: true
            },
            pageTrack: '/payment'
        })
}

module.exports = 'pages.booking';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/booking/index.js
 ** module id = 259
 ** module chunks = 1
 **/